export function isEmptyText(text) {
  return !(text && text.replace(/\s+/g, ''));
}